import { ANALYZE_FOR_ENTRY_COMPONENTS, ModuleWithProviders, NgModule } from '@angular/core';
import { CbjScrollModule, ScrollbarService, WINDOW, _window, WindowService } from './scroll/index';
import { CbjButtonModule } from './buttons/index';
import { CbjDatatableModule, CbjLinkCellComponent } from './datatable/index';
import { CbjNavsModule } from './navs/index';
import { CbjLayoutModule } from './layout/index';
import { CbjPipesModule } from './pipes/index';
import { CbjRippleModule } from './ripple/index';
import { CbjMenuModule } from './menu/index';
import { CbjGalleryModule } from './gallery/index';
export class CbjUiModule {
constructor () { }
/**
 * @return {?}
 */
static forRoot(): ModuleWithProviders {
    return {
      ngModule: CbjUiModule,
      providers: [
        { provide: WINDOW, useFactory: _window },
        WindowService,
        ScrollbarService,
        {provide: ANALYZE_FOR_ENTRY_COMPONENTS, multi: true, useValue: [CbjLinkCellComponent]}
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  exports: [
    CbjScrollModule,
    CbjRippleModule,
    CbjButtonModule,
    CbjMenuModule,
    CbjNavsModule,
    CbjPipesModule,
    CbjDatatableModule,
    CbjLayoutModule,
    CbjGalleryModule,
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjUiModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjUiModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjUiModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
